<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li>
              <li class="breadcrumb-item active">Dashboard</li>
            </ol>
          </div>
          <h4 class="page-title">Settlement</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div class="card-box">
          <h4 class="header-title">Settlement</h4>
          <p class="sub-header">
            Search Transactions
          </p>

          <div class="row">

            <div class="col-12">
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0"
                     style="width: 100%">
                <thead>
                <tr>

                  <th *ngFor="let column of columns">
                    <ng-container *ngIf="searchableColumns[column.data] != null && searchableColumns[column.data].searchable">

                      <ng-container *ngIf="searchableColumns[column.data].inputType == 'string'">
                        <input [(ngModel)]="column.search.value" (ngModelChange)="this.searchDebounce.next($event)" class="form-control" type="text" placeholder="Search {{column.title}}"/>
                      </ng-container>

                      <ng-container *ngIf="searchableColumns[column.data].inputType == 'dateRange'">
                        <div class="input-group">
                          <input name="datepicker"
                                 hidden
                                 class="form-control "
                                 ngbDatepicker
                                 #datepicker="ngbDatepicker"
                                 [autoClose]="'outside'"
                                 (dateSelect)="onDateSelection($event);"
                                 [dayTemplate]="t"
                                 outsideDays="hidden"
                                 [startDate]="fromDate"
                          >
                          <ng-template #t let-date let-focused="focused">
                                 <span class="custom-day"
                                       [class.focused]="focused"
                                       [class.range]="isRange(date)"
                                       [class.faded]="isHovered(date) || isInside(date)"
                                       (mouseenter)="hoveredDate = date"
                                       (mouseleave)="hoveredDate = null">
                                    {{ date.day }}
                                  </span>
                          </ng-template>

                          <div>

                            <div class="input-group  date-range">
                              <input class="form-control" placeholder="Search by Date Range"
                                     (click)="datepicker.toggle()"
                                     [value]="getDateFilterValue()">

                              <div class="input-group-append">
                                <button class="btn btn-outline-secondary calendar" (click)="datepicker.toggle()" type="button"><i class="mdi mdi-calendar"></i></button>
                              </div>
                            </div>


                          </div>

                        </div>
                      </ng-container>


                    </ng-container>
                  </th>
                </tr>
                <tr>
                  <th *ngFor="let column of dtOptions.columns">
                    {{column.data}}
                  </th>
                  <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let settlement of settlements">
                  <td *ngFor="let column of displayColumns">

                    <ng-container *ngIf="column.render">
                      <div [innerHtml]="resolveData(settlement, column.data, column.render)| safe:'html'"></div>
                    </ng-container>
                    <ng-container *ngIf="!column.render">
                      {{resolveData(settlement, column.data)}}
                    </ng-container>

                  </td>
                  <td style="white-space: nowrap; width: 1%;">
                    <div class="tabledit-toolbar btn-toolbar" style="text-align: left;">
                      <div class="btn-group btn-group-sm" >
                        <button type="button" class="tabledit-edit-button btn btn-primary" [style]="Action_Hold" *ngIf="!(getParameterCaseInsensitive(settlement, 'TransactionHold') || getParameterCaseInsensitive(settlement, 'MerchantHold') || getParameterCaseInsensitive(settlement, 'TerminalHold'))"
                                (click)="holdTransactionClick(settlement)"><span
                          class="mdi mdi-pencil-box-outline">Hold</span></button>
                        <button type="button" class="tabledit-edit-button btn btn-outline-danger" [style]="Action_Release" *ngIf="getParameterCaseInsensitive(settlement, 'TransactionHold') || getParameterCaseInsensitive(settlement, 'MerchantHold') || getParameterCaseInsensitive(settlement, 'TerminalHold')"
                                (click)="releaseTransactionClick(settlement)"><span
                          class="mdi mdi-pencil-box-outline">Release</span></button>
                        <button type="button" class="tabledit-edit-button btn btn-outline-info" [style]="Action_Release" *ngIf="getParameterCaseInsensitive(settlement, 'HoldBy')"
                                (click)="displayInfo(settlement)"><span
                          class="mdi mdi-eye-outline">Details</span></button>
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>

      </div>

    </div>

  </div> <!-- end container -->
</div>
